var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 6.50521H9.83268V4.83854H8.16602V6.50521ZM8.99935 15.6719C5.32435 15.6719 2.33268 12.6802 2.33268 9.00521C2.33268 5.33021 5.32435 2.33854 8.99935 2.33854C12.6743 2.33854 15.666 5.33021 15.666 9.00521C15.666 12.6802 12.6743 15.6719 8.99935 15.6719ZM8.99935 0.671875C7.905 0.671875 6.82137 0.887423 5.81032 1.30621C4.79927 1.725 3.88061 2.33883 3.10679 3.11265C1.54399 4.67546 0.666016 6.79507 0.666016 9.00521C0.666016 11.2153 1.54399 13.335 3.10679 14.8978C3.88061 15.6716 4.79927 16.2854 5.81032 16.7042C6.82137 17.123 7.905 17.3385 8.99935 17.3385C11.2095 17.3385 13.3291 16.4606 14.8919 14.8978C16.4547 13.335 17.3327 11.2153 17.3327 9.00521C17.3327 7.91086 17.1171 6.82723 16.6983 5.81618C16.2796 4.80513 15.6657 3.88647 14.8919 3.11265C14.1181 2.33883 13.1994 1.725 12.1884 1.30621C11.1773 0.887423 10.0937 0.671875 8.99935 0.671875ZM8.16602 13.1719H9.83268V8.17188H8.16602V13.1719Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.220083b2.svg";
export { ForwardRef as ReactComponent };